import React  from 'react';
import { Link } from 'react-router-dom';

import CheckMark from "../CheckMark";
import BetImg    from "~/assets/images/dailyGoals/lottery.png";


const PlayBetGoal = ({status, user})=> {

  if(user.level < 2) return null;

  return (
    <Link className="item-goal" to={"/jackpot"}>

      <CheckMark done={status} />
      <div>
        <h5 className={"item-title"}> 1 Hi and Low play </h5>
        <p>Increase your points or tokens by playing the Hi-Low game</p>
      </div>
      <img src={BetImg} className="icon"/>
    </Link>
  )
}

export default PlayBetGoal;
